import { useQuery } from '@apollo/client';
import { Avatar, Box, Grid, Group, Loader, Paper, ScrollArea, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { customerDocument } from '../graphql/customer';

export const CustomerDetails = () => {
  const { customerId } = useParams();

  const viewport = useRef<HTMLDivElement>(null);

  const { data, loading } = useQuery(customerDocument, {
    variables: { where: { id: customerId } },
    skip: !customerId,
  });

  useEffect(() => {
    if (data?.customer?.messages && data.customer.messages.length > 0)
      viewport.current?.scrollTo({ top: viewport.current!.scrollHeight, behavior: 'smooth' });
  }, [data?.customer?.messages]);

  if (loading) return <Loader />;

  if (!data?.customer) return <Box>No data</Box>;

  return (
    <Grid>
      <Grid.Col span={4}>
        <Paper withBorder p="md">
          <Avatar src={data.customer.avatar} size="xl" mx="auto" />
          <Text ta="center" fz="lg" fw={500} mt="md">
            {data.customer.name}
          </Text>
          <Text ta="center" c="dimmed" fz="sm">
            {[data.customer.email, dayjs(data.customer.createdAt).format('DD MMM YYYY HH:mm')]
              .filter((val) => Boolean(val))
              .join('•')}
          </Text>
          <Group mt="md" justify="center" gap={30}>
            <Box>
              <Text ta="center" fz="lg" fw={500}>
                {data.customer._count.orders}
              </Text>
              <Text ta="center" fz="sm" c="dimmed" lh={1}>
                Orders
              </Text>
            </Box>
            <Box>
              <Text ta="center" fz="lg" fw={500}>
                {data.customer._count.messages}
              </Text>
              <Text ta="center" fz="sm" c="dimmed" lh={1}>
                Messages
              </Text>
            </Box>
            <Box>
              <Text ta="center" fz="lg" fw={500}>
                {data.customer._count.addresses}
              </Text>
              <Text ta="center" fz="sm" c="dimmed" lh={1}>
                Addresses
              </Text>
            </Box>
          </Group>
        </Paper>
      </Grid.Col>
      <Grid.Col span={8}>
        <Paper withBorder p="md">
          <ScrollArea viewportRef={viewport} h={500}>
            <Stack gap="xs">
              {data.customer.messages
                ?.slice()
                .reverse()
                .map((message) => (
                  <Group
                    key={message.id}
                    maw="70%"
                    style={{
                      alignSelf: message.isEcho ? 'flex-end' : 'flex-start',
                      flexDirection: message.isEcho ? 'row-reverse' : 'row',
                    }}
                  >
                    <Avatar
                      src={!message.isEcho ? message.customer.avatar : undefined}
                      name={message.isEcho ? 'Lásky Krásky' : message.customer.name}
                    />
                    <Paper
                      key={message.id}
                      p="sm"
                      bg={message.isEcho ? 'dark' : 'gray'}
                      radius="md"
                      component={Stack}
                      gap={0}
                    >
                      <Text>{message.body}</Text>
                      <Text
                        size="sm"
                        c="dimmed"
                        style={{
                          alignSelf: message.isEcho ? 'flex-end' : 'flex-start',
                        }}
                      >
                        {dayjs(message.createdAt).format('DD.MM.YYYY HH:mm:ss')}
                      </Text>
                    </Paper>
                  </Group>
                ))}
            </Stack>
          </ScrollArea>
        </Paper>
      </Grid.Col>
    </Grid>
  );
};
